import { Dropdown } from 'bootstrap';
import '../css/article.css';
import './utils/legacy-movie-runtime';
const InfiniteScroll = require('infinite-scroll');
const imagesLoaded = require('imagesloaded');
const Isotope = require('isotope-layout');

const SHOWTIMES_AVAILABLE_IN_LABEL = 'Chỉ có lịch chiếu ở các khu vực:';
const SHOWTIMES_UNAVAILABLE_LABEL = 'Không có lịch chiếu phù hợp với điều kiện tìm kiếm của bạn.<br />Hãy thử chọn một ngày khác hoặc định dạng khác.';
const MAP_LABEL = 'Bản đồ';
const CINEMA_INFO_LABEL = 'Thông tin rạp';
const GENRES_LABEL = 'Thể loại';
const LANGUAGES_LABEL = 'Ngôn ngữ';
const ORDER_LABEL = 'Sắp xếp';
// Cineplex có hợp tác affiliate ZaloPay: 18784 CGV, 18783 Galaxy, 18785 Lotte (MVK-3411).
// BHD (18788) đã gỡ ở MVK-2351 — không có hợp tác affiliate nên suất chiếu BHD
// không sang ZaloPay, ghi chú ZLP dưới rạp là sai. Thêm lại khi deal ZLP mở BHD.
const ZALOPAY_AFFILIATE_CINEPLEX_IDS = [18784, 18783, 18785];

function updateText(selector, value) {
    document.querySelectorAll(selector).forEach((el) => {
        el.textContent = value;
    });
}

function setSelectValueAndDispatchChange(selectEl, value) {
    if (!selectEl) return;

    selectEl.value = value;
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
}

function hideDropdown(toggleSelector) {
    const toggle = document.querySelector(toggleSelector);
    if (!toggle) return;

    // MVK-3409 — BS5 giữ trạng thái trong instance `Dropdown` (class `show` nằm ở toggle + menu, không ở `.dropdown`).
    Dropdown.getOrCreateInstance(toggle).hide();
}

let grid;
const boundShowtimesRegionSelects = new WeakSet();
const boundShowtimesVersionSelects = new WeakSet();
let bindShowtimesDatesEl;
let bindShowtimesDatesClickHandler;
let bindShowtimesContainerEl;
let bindShowtimesContainerClickHandler;
let bindShowtimesCollapseObserver;

function findShowtimesControlsScope(showtimesEl) {
    let scope = showtimesEl ? showtimesEl.parentElement : null;

    while (scope) {
        if (scope.querySelector('.btn-select-region') && scope.querySelector('.btn-select-version')) {
            return scope;
        }

        scope = scope.parentElement;
    }

    return null;
}

function loadCinemaShowtimes(collapseEl) {
    if (!collapseEl || !collapseEl.classList.contains('show')) return;

    const parent = collapseEl.closest('.btn-select-cinema');
    if (!parent) return;

    const cinemaId = parent.dataset.cinemaId;
    const showtimesContent = parent.querySelector('.showtimes');
    if (!showtimesContent || showtimesContent.classList.contains('loaded') || showtimesContent.classList.contains('loading')) return;

    showtimesContent.classList.add('loading');

    fetch(generateRouteUrl('orn_web_showtime_movie', {
        id: params.id,
        date: params.date,
        cinema: cinemaId,
        version: params.version,
        ticketing: params.ticketing
    }))
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Failed to load showtimes: ${response.status}`);
            }

            return response.text();
        })
        .then((html) => {
            showtimesContent.innerHTML = html;
            showtimesContent.classList.add('loaded');
            doGetShowtimePrice(html);
            appendUtmToAffiliateLinks();
        })
        .catch(() => {})
        .finally(() => {
            showtimesContent.classList.remove('loading');
        });
}

window.bindMovies = () => {
    const genre = getGenre();
    const language = getLanguage();
    const sort = getSort();

    const gridElement = document.querySelector('.grid');
    if (!gridElement) return;

    imagesLoaded(gridElement, () => {
        grid = new Isotope(gridElement, {
            itemSelector: '.item',
            layoutMode: 'fitRows',
            getSortData: {
                latest: '[data-release]',
                popular: '[data-popularity]'
            }
        });

        doFilter();
    });

    doChooseGenre(genre);
    doChooseLanguage(language);
    doChooseSort(sort);

    document.querySelectorAll('.btn-choose-genre').forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();

            const genre = event.currentTarget.dataset.genre;
            doChooseGenre(genre);
            doFilter();
        });
    });

    document.querySelectorAll('.btn-choose-language').forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();

            const language = event.currentTarget.dataset.language;
            doChooseLanguage(language);
            doFilter();
        });
    });

    document.querySelectorAll('.btn-choose-sort').forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();

            const sort = event.currentTarget.dataset.sort;
            doChooseSort(sort);

            if (!grid) return;

            if (sort === 'alphabet') {
                grid.arrange({ sortBy: sort, sortAscending: true });
            } else {
                grid.arrange({ sortBy: sort, sortAscending: false });
            }
        });
    });
};

window.bindShowtimes = () => {
    const showtimesEl = document.getElementById('showtimes');
    const showtimesScope = findShowtimesControlsScope(showtimesEl);
    const regionSelect = showtimesScope ? showtimesScope.querySelector('.btn-select-region') : null;
    const versionSelect = showtimesScope ? showtimesScope.querySelector('.btn-select-version') : null;
    const datesEl = showtimesScope ? showtimesScope.querySelector('#dates') : null;

    if (regionSelect && !boundShowtimesRegionSelects.has(regionSelect)) {
        regionSelect.addEventListener('change', (event) => {
            const region = event.currentTarget.value;
            setRegion(region);

            params.region = region;
            doGetShowtimes();
        });

        boundShowtimesRegionSelects.add(regionSelect);
    }

    if (versionSelect && !boundShowtimesVersionSelects.has(versionSelect)) {
        versionSelect.addEventListener('change', (event) => {
            params.version = event.currentTarget.value;
            doGetShowtimes();
        });

        boundShowtimesVersionSelects.add(versionSelect);
    }

    if (datesEl) {
        if (bindShowtimesDatesEl && bindShowtimesDatesClickHandler) {
            bindShowtimesDatesEl.removeEventListener('click', bindShowtimesDatesClickHandler);
        }

        bindShowtimesDatesClickHandler = (event) => {
            const dateBtn = event.target.closest('.date');
            if (!dateBtn || !datesEl.contains(dateBtn)) return;

            event.preventDefault();
            params.date = dateBtn.dataset.date;

            if (!dateBtn.classList.contains('active')) {
                document.querySelectorAll('#dates .date').forEach((el) => el.classList.remove('active'));
                dateBtn.classList.add('active');
                doGetShowtimes();
            }
        };

        datesEl.addEventListener('click', bindShowtimesDatesClickHandler);
        bindShowtimesDatesEl = datesEl;
    }

    if (showtimesEl) {
        if (bindShowtimesContainerEl && bindShowtimesContainerClickHandler) {
            bindShowtimesContainerEl.removeEventListener('click', bindShowtimesContainerClickHandler);
        }

        bindShowtimesContainerClickHandler = (event) => {
            const regionBtn = event.target.closest('.btn-choose-region');
            if (!regionBtn || !showtimesEl.contains(regionBtn)) return;

            event.preventDefault();
            setSelectValueAndDispatchChange(regionSelect, regionBtn.dataset.regionId);
        };

        showtimesEl.addEventListener('click', bindShowtimesContainerClickHandler);
        bindShowtimesContainerEl = showtimesEl;

        if (bindShowtimesCollapseObserver) {
            bindShowtimesCollapseObserver.disconnect();
        }

        bindShowtimesCollapseObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;

                const collapseEl = mutation.target;
                if (!collapseEl.matches('.cinema.collapse.show')) return;

                loadCinemaShowtimes(collapseEl);
            });
        });

        bindShowtimesCollapseObserver.observe(showtimesEl, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    doGetShowtimes();
};

window.bindInfiniteScroll = function (isAutoLoad) {
    const container = document.querySelector('.card-infinite');
    if (!container) return;

    const options = {
        path: params.url + '?page={{#}}',
        append: '.article',
        history: false,
        status: '.page-load-status',
        // MVK-3686: infinite-scroll 5 dùng fetch(), không tự gửi header này; thiếu nó controller trả cả trang thay vì fragment.
        fetchOptions: { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    };
    if (isAutoLoad === false) {
        options.button = '.btn-view-more';
        options.scrollThreshold = false;
    }

    const infScroll = new InfiniteScroll(container, options);

    infScroll.on('history', function () {
        dataLayer.push({
            'event': 'virtualPageView',
            'virtualUrl': location.pathname
        });
    });

    infScroll.on('load', function (response) {
        const text = response.body ? response.body.textContent : '';
        if (!text.trim()) {
            infScroll.destroy();

            const requestEl = document.querySelector('.page-load-status .infinite-scroll-request');
            const lastEl = document.querySelector('.page-load-status .infinite-scroll-last');

            if (requestEl) requestEl.style.display = 'none';
            if (lastEl) lastEl.style.display = '';
        }
    });
};

window.bindComments = () => {
    const limit = 5;
    let page = 1;
    const commentsEl = document.querySelector('.comments');
    if (!commentsEl) return;

    const getHiddenComments = () => Array.from(document.querySelectorAll('.block-comment.d-none'));

    if (params.totalComments > limit) {
        const btn = document.createElement('a');
        btn.href = '#';
        btn.className = 'btn btn-light w-100 btn-fake-load-more mb-3';
        btn.textContent = 'Xem thêm';
        commentsEl.appendChild(btn);

        document.querySelectorAll('.block-comment').forEach((comment, index) => {
            if (index >= limit) comment.classList.add('d-none');
        });
    }

    commentsEl.addEventListener('click', (event) => {
        const btn = event.target.closest('.btn-fake-load-more');
        if (!btn) return;

        event.preventDefault();
        page += 1;
        const visibleCount = limit * page;

        document.querySelectorAll('.block-comment').forEach((comment, index) => {
            if (index < visibleCount) comment.classList.remove('d-none');
        });

        if (getHiddenComments().length === 0) {
            btn.remove();
        }
    });
};

window.bindRatingSummary = (tab) => {
    const rating = params[tab];
    const percentageEls = document.querySelectorAll('.summary-rating-percentage');
    const pointEls = document.querySelectorAll('.summary-rating-point');
    const totalEls = document.querySelectorAll('.summary-rating-total');
    const descriptionEls = document.querySelectorAll('.summary-rating-description');
    const progressBars = document.querySelectorAll('.summary-rating-progress .progress-bar');

    percentageEls.forEach((el) => {
        el.textContent = rating.percentage;
        const parent = el.closest('p');
        if (parent) {
            parent.classList.remove('text-success', 'text-danger', 'text-secondary');
        }
    });

    pointEls.forEach((el) => {
        el.textContent = rating.point;
    });

    totalEls.forEach((el) => {
        el.textContent = rating.total;
    });

    progressBars.forEach((bar) => {
        bar.style.width = `${rating.percentage}%`;
        bar.classList.remove('bg-success', 'bg-danger', 'bg-secondary');
    });

    let description = 'Đa số người xem đánh giá';
    if (rating.max.type === 'bad') {
        description += ' tiêu cực về bộ phim. ';
        if (rating.range.good.percentage > 0) {
            description += `Chỉ ${rating.range.good.percentage}% nhận xét phim hay.`;
        }
    }
    if (rating.max.type === 'avg') {
        description += ' phim ở mức trung bình. ';
        if (rating.range.good.percentage > 0) {
            description += `${rating.range.good.percentage}% nhận xét phim hay.`;
        }
    }
    if (rating.max.type === 'good') {
        description += ' tích cực về bộ phim. ';
        if (rating.range.bad.percentage > 0) {
            description += `Chỉ ${rating.range.bad.percentage}% nhận xét phim không hay.`;
        }
    }

    let textClass = 'text-secondary';
    let barClass = 'bg-secondary';
    if (rating.percentage >= 80) {
        textClass = 'text-success';
        barClass = 'bg-success';
    } else if (rating.percentage < 50) {
        textClass = 'text-danger';
        barClass = 'bg-danger';
    }

    percentageEls.forEach((el) => {
        const parent = el.closest('p');
        if (parent) parent.classList.add(textClass);
    });

    progressBars.forEach((bar) => {
        bar.classList.add(barClass);
    });

    descriptionEls.forEach((el) => {
        el.textContent = description;
    });
};

let showtimesRequestToken = 0;

function doGetShowtimes() {
    const showtimesEl = document.getElementById('showtimes');
    const requestToken = ++showtimesRequestToken;

    if (params.id && params.date) {
        if (showtimesEl) {
            showtimesEl.innerHTML = '<div class="text-center mb-3"> <div class="text-muted spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
        }
        fetch(generateRouteUrl('orn_web_showtime_movie', {
            id: params.id,
            date: params.date,
            region: params.region,
            version: params.version,
            ticketing: params.ticketing
        }))
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Showtimes request failed with status ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                let html;
                if (data.cineplexes.length > 0) {
                    html = '<div class="card"><div class="list-group list-group-flush">';
                    for (const v of data.cineplexes) {
                        let cinemas = '';
                        for (const c of v.cinemas) {
                            cinemas += doRenderCinema(c);
                        }

                        const sponsoredClass = v.sponsored === 1 ? ` sponsored-cineplex-tracking sponsored-cineplex sponsored-cineplex-${v.data.id}` : '';
                        const collapseShow = v.sponsored === 1 ? ' show' : '';
                        const affiliateShow = ZALOPAY_AFFILIATE_CINEPLEX_IDS.includes(v.data.id) ? '<div class="mt-2 small text-muted"><strong>Giảm 30% với mã ZLPMOVEEK</strong>.\nChọn suất chiếu để sang ZaloPay chọn ghế &amp; thanh toán.\nHỗ trợ: 1900 545436</div>' : '';
                        const affiliateShowMobile = affiliateShow ? `<div class="d-md-none d-sm-block">${affiliateShow}</div>` : ''
                        const affiliateShowDesktop = affiliateShow ? `<div class="col-7 d-none d-lg-block">${affiliateShow}</div>` : ''

                        html += `<a href="#" class="list-group-item bg-light btn-select-cineplex${sponsoredClass}" data-cineplex="${v.data.slug}" data-bs-toggle="collapse" data-bs-target="#showtime-cineplex-${v.data.id}"><div class="row align-items-center"><div class="col-auto"><div class="avatar avatar-sm"><img src="${v.data.image}" alt="${v.data.name}" class="avatar-img rounded"></div> </div><div class="col ms-n2"><h4 class="text-body mb-1 name">${v.data.name}</h4><p class="small text-muted mb-0">${v.cinemas.length} rạp</p></div>${affiliateShowDesktop}<div class="col-auto"><span class="text-muted h3"><i class="fe fe-chevron-right"></i></span></div></div>${affiliateShowMobile}</a><div class="list-group collapse${collapseShow}" id="showtime-cineplex-${v.data.id}">${cinemas}</div>`;
                    }
                    html += '</div></div>';
                } else {
                    if (data.regions.length > 0) {
                        const regions = data.regions.map((r, i) =>
                            `<a href="#" class="fw-bold text-dark btn-choose-region" data-region-id="${r.id}">${r.name}</a>${i < data.regions.length - 1 ? ', ' : ''}`
                        ).join('');

                        html = `<div class="alert alert-light">${SHOWTIMES_AVAILABLE_IN_LABEL} ${regions}</div>`;
                    } else {
                        html = `<div class="alert alert-light">${SHOWTIMES_UNAVAILABLE_LABEL}</div>`;
                    }
                }

                if (requestToken !== showtimesRequestToken) return;

                if (showtimesEl) {
                    showtimesEl.innerHTML = html;
                    showtimesEl.querySelectorAll('.sponsored-cinema').forEach((sponsoredCinema) => {
                        sponsoredCinema.click();
                    });
                }
            })
            .catch(() => {
                if (requestToken !== showtimesRequestToken) return;

                if (showtimesEl) {
                    showtimesEl.innerHTML = `<div class="alert alert-light">${SHOWTIMES_UNAVAILABLE_LABEL}</div>`;
                }
            });
    } else {
        if (showtimesEl) {
            showtimesEl.innerHTML = `<div class="alert alert-light">${SHOWTIMES_UNAVAILABLE_LABEL}</div>`;
        }
    }
}

function doRenderCinema(c) {
    const mapHtml = ` - <a href="https://maps.google.com/?q=${c.name}" target="_blank">${MAP_LABEL}</a>`;
    const infoHtml = ` - <a href="${generateRouteUrl('cinema_view', { slug: c.slug })}">${CINEMA_INFO_LABEL}</a>`;

    const sponsoredClass = c.sponsored === 1 ? ` sponsored-cinema-tracking sponsored-cinema sponsored-cinema-${c.id}` : '';
    const ticketingClass = c.ticketing === 1 ? ` ticketing-cinema-tracking ticketing-cinema ticketing-cinema-${c.id}` : '';

    // MVK-3409 — toggle collapse là tiêu đề rạp, KHÔNG phải cả khối: BS5 `preventDefault()` mọi click có `event.target` là
    // `<a>` bên trong toggle ⇒ link "Thông tin rạp"/"Bản đồ" và nút suất chiếu trong panel sẽ chết nếu panel nằm trong toggle.
    return `<div class="list-group-item btn-select-cinema${sponsoredClass} ${ticketingClass}" data-cineplex="${c.cineplex}" data-cinema="${c.slug}" data-cinema-id="${c.id}"><h4 class="text-body mb-0 name fw-normal" role="button" data-bs-toggle="collapse" data-bs-target="#showtime-cinema-${c.id}">${c.name}</h4><div class="cinema collapse mt-0" id="showtime-cinema-${c.id}"><p class="small text-muted mb-3">${c.location.address}${infoHtml}${mapHtml}</p><div class="showtimes"><div class="text-center text-muted"><div class="spinner-border spinner-border-sm" role="status"></div></div></div></div></div>`;
}

function doFilter() {
    const genre = getGenre();
    const language = getLanguage();
    const hasLanguageFilter = document.querySelector('.language-dropdown') !== null;

    const filterLanguage = hasLanguageFilter && language !== 'all' ? `.language-${language}` : '*';
    const filterGenre = genre === 'all' ? '*' : `.genre-${genre}`;
    let filterStr = filterLanguage + filterGenre;
    if (filterLanguage === '*' && filterGenre === '*') {
        filterStr = '*';
    }

    if (!grid) return;

    grid.arrange({ filter: filterStr });
}

function doChooseGenre(genre) {
    document.querySelectorAll('.btn-choose-genre').forEach((btn) => btn.classList.remove('active'));

    const activeBtn = document.querySelector(`.btn-choose-genre[data-genre="${genre}"]`);
    if (activeBtn) activeBtn.classList.add('active');

    setGenre(genre);

    const name = activeBtn ? activeBtn.textContent.trim() : '';
    updateText('.genre-dropdown > a', genre === 'all' ? GENRES_LABEL : name);
    hideDropdown('.genre-dropdown > a');
}

function doChooseLanguage(language) {
    document.querySelectorAll('.btn-choose-language').forEach((btn) => btn.classList.remove('active'));

    const activeBtn = document.querySelector(`.btn-choose-language[data-language="${language}"]`);
    if (activeBtn) activeBtn.classList.add('active');

    setLanguage(language);

    const name = activeBtn ? activeBtn.textContent.trim() : '';
    updateText('.language-dropdown > a', language === 'all' ? LANGUAGES_LABEL : name);
    hideDropdown('.language-dropdown > a');
}

function doChooseSort(sort) {
    document.querySelectorAll('.btn-choose-sort').forEach((btn) => btn.classList.remove('active'));

    const activeBtn = document.querySelector(`.btn-choose-sort[data-sort="${sort}"]`);
    if (activeBtn) activeBtn.classList.add('active');

    setSort(sort);

    const name = activeBtn ? activeBtn.textContent.trim() : '';
    updateText('.sort-dropdown > a', sort === 'all' ? ORDER_LABEL : name);
    hideDropdown('.sort-dropdown > a');
}

// MVK-3906 — sự kiện GA của skin cũ trang phim `/phim/{slug}/` (spec §6.7: baseline để so với skin Flowbite, cùng tên + trường,
// `ui: 'legacy'`; bản Flowbite ở assets/js/pages/movie/analytics.js):
//   movie_view     { event, ui, movie_id }                              — một lần mỗi lần tải trang
//   showtime_click { event, ui, movie_id, cinema_id, showtime_id }      — bấm chip giờ có thể mua/chuyển sang web rạp
// Entry `movie` còn nạp ở country/local/now/rating-movie; chỉ trang phim có `#showtimes` + `params.id` (`const params` là
// binding toàn cục chứ không phải `window.params`, nên dò bằng `typeof`). Chip do XHR chèn vào `#showtimes` sau đó ⇒ listener
// uỷ quyền gắn lên container (còn nguyên khi `innerHTML` bị thay). `cinema_id` lấy ở khối rạp `[data-cinema-id]` (chip chỉ mang
// slug trong `data-cinema`); `showtime_id` = `data-reference` (externalId suất, như skin Flowbite).
// Tập chip đếm khớp skin Flowbite: bỏ `.is-nothing` (href="#", rạp không bán online/bị tắt — bên Flowbite là `<span>`) và
// `.disabled` (suất đã chiếu — bên Flowbite là `pointer-events-none`).
function initLegacyMovieAnalytics() {
    if (typeof params === 'undefined' || !params || !params.id) return;
    const showtimesEl = document.getElementById('showtimes');
    if (!showtimesEl) return;

    const movieId = String(params.id);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'movie_view', ui: 'legacy', movie_id: movieId });

    showtimesEl.addEventListener('click', (event) => {
        const chip = event.target instanceof Element ? event.target.closest('.btn-showtime[data-reference]:not(.is-nothing):not(.disabled)') : null;
        if (!chip || !showtimesEl.contains(chip)) return;

        const cinema = chip.closest('[data-cinema-id]');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'showtime_click',
            ui: 'legacy',
            movie_id: movieId,
            cinema_id: cinema ? cinema.dataset.cinemaId : '',
            showtime_id: chip.dataset.reference
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLegacyMovieAnalytics, { once: true });
} else {
    initLegacyMovieAnalytics();
}
